// import {
//   Box,
//   Flex,
//   Button,
//   useColorModeValue,
//   Stack,
//   useColorMode,
//   Show,
//   HStack,
//   Text,
//   useDisclosure,
//   IconButton,
//   Hide,
// } from "@chakra-ui/react";
// import {
//   MoonIcon,
//   SunIcon,
//   HamburgerIcon,
//   CloseIcon,
//   AddIcon,
// } from "@chakra-ui/icons";
// import Photo from "./Photo";
// import Name from "./Name";
// import "./Navbar.css";
// import Shubham_Verma_Resume from "./Shubham_Verma_Resume.pdf";

// export default function Navbar() {
//   const { colorMode, toggleColorMode } = useColorMode();
//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const onButtonClick = () => {
//     const link = document.createElement("a");
//     link.href = Shubham_Verma_Resume;
//     link.download = "Shubham_Verma_Resume.pdf";
//     link.click();
//   };

//   return (
//     <div  id="nav-menu">
//       <Box
//         bg={useColorModeValue("gray.100", "gray.900")}
//         px={9}
//         width={["100%"]}
//       >
//         <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
//           <HStack w="42%">
//             <Name />

//             <Show breakpoint="(min-width: 1000px)">
//               {" "}
//               {/* <Photo /> */}
//             </Show>
//           </HStack>

//           <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
           
//             <HStack spacing={8} alignItems={"center"}>
//               <HStack
//                 as={"nav"}
//                 spacing={4}
//                 display={{ base: "none", md: "flex" }}
//                 id="myDIV"
//               >
//                 <Button className="nav-link home">
//                   <a href="#home">
//                     {" "}
//                     <b>Home</b>
//                   </a>
//                 </Button>

//                 <Button className="nav-link about">
//                   <a href="#about">
//                     <b>About</b>
//                   </a>
//                 </Button>

//                 <Button className="nav-link skills">
//                   <a href="#skills">
//                     {" "}
//                     <b>Skills</b>
//                   </a>
//                 </Button>

//                 <Button className="nav-link projects">
//                   <a href="#projects">
//                     <b>Projects</b>
//                   </a>
//                 </Button>

//                 <Button className="nav-link contact">
//                   <a href="#contact">
//                     <b>Contact</b>
//                   </a>
//                 </Button>
//               </HStack>
//             </HStack>
//           </Flex>

         

//           <Flex alignItems={"center"}>
//             <Stack direction={"row"} spacing={7}>
//               <Button onClick={toggleColorMode}>
//                 {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
//               </Button>

//               <Button
//             backgroundColor="#a891b7"
//             _hover={{ bg: "#a891b7", color: "black" }}
//             color="white"
//             variant="solid"
//             onClick={onButtonClick}
//             size={["sm", "md"]}
//             id="resume-button-1"
//           >
//             RESUME
//           </Button>
//             </Stack>
//           </Flex>
//           <IconButton
//             size={"md"}
//             icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
//             aria-label={"Open Menu"}
//             display={{ md: "none" }}
//             onClick={isOpen ? onClose : onOpen}
//           />
//           {isOpen ? (
//             <Box pb={4} display={{ md: "none" }}>
//               <Stack as={"nav"} spacing={4}>
//                 <Button  onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}>
//                   <a href="#Home">
//                     {" "}
//                     <b>Home</b>
//                   </a>
//                 </Button>
//                 <Button  onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}>
//                   <a href="#Home">
//                     {" "}
//                     <b>Home</b>
//                   </a>
//                 </Button>

//                 <Button  onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}>
//                   <a href="#Home">
//                     {" "}
//                     <b>Home</b>
//                   </a>
//                 </Button>
//                 <Button  onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}>
//                   <a href="#Home">
//                     {" "}
//                     <b>Home</b>
//                   </a>
//                 </Button>
//                 <Button
//                   onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}
//                 >
//                   <a href="#Home">
//                     {" "}
//                     <b>Home</b>
//                   </a>
//                 </Button>

//                 <Button
//                   onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}
//                 >
//                   <a href="#About">
//                     <b>About</b>
//                   </a>
//                 </Button>

//                 <Button
//                   onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}
//                 >
//                   <a href="#Skills">
//                     {" "}
//                     <b>Skills</b>
//                   </a>
//                 </Button>

//                 <Button
//                   onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}
//                 >
//                   <a href="#Projects">
//                     <b>Projects</b>
//                   </a>
//                 </Button>

//                 <Button
//                   onClick={isOpen ? onClose : onOpen}
//                   _hover={{
//                     textShadow: "#FC0 1px 0 10px",
//                     transform: "scale(1.2)",
//                   }}
//                 >
//                   <a href="#Contact">
//                     <b>Contact</b>
//                   </a>
//                 </Button>
//               </Stack>
//             </Box>
//           ) : null}
//         </Flex>
//       </Box>
//     </div>
//   );
// }






import {
  Box,
  Flex,
  Button,
  useColorModeValue,
  Stack,
  useColorMode,
  Show,
  HStack,
  Text,
  useDisclosure,
  IconButton,
  Hide,
} from "@chakra-ui/react";
import {
  MoonIcon,
  SunIcon,
  HamburgerIcon,
  CloseIcon,
  AddIcon,
} from "@chakra-ui/icons";
import Photo from "./Photo";
import Name from "./Name";
import "./Navbar.css";

export default function Navbar() {
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onButtonClick = () => {
      window.open("https://drive.google.com/file/d/1EYpEpzdVOVw07ZeoE-uojOc6LOqaBX6w/view?usp=sharing","_blank")
      const fileID = "1EYpEpzdVOVw07ZeoE-uojOc6LOqaBX6w"; // Replace with your file's ID
      const fileName = "Kamalakanta-Mahapatra.pdf"; // Replace with the desired file name
      
      // Create a direct download link
      const downloadLink = `https://drive.google.com/uc?export=download&id=${fileID}`;
      
      // Create an invisible link element
      const link = document.createElement("a");
      link.href = downloadLink;
      link.target = "_blank"; // Open the link in a new tab/window
      link.download = fileName;
    
      // Trigger the click event on the link to initiate the download
      link.click();
  };
  

  return (
    <div id="nav-menu">
      <Box
        bg={useColorModeValue("gray.100", "gray.900")}
        px={9}
        width={["100%"]}
      >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <HStack w="42%">
            <Name />

            <Show breakpoint="(min-width: 1000px)">
              {/* <Photo /> */}
            </Show>
          </HStack>

          <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
            <HStack spacing={8} alignItems={"center"}>
              <HStack
                as={"nav"}
                spacing={4}
                display={{ base: "none", md: "flex" }}
                id="myDIV"
              >
                <a href="#home">
                <Button className="nav-link home">
                    {" "}
                    <b>Home</b>
                </Button>
                </a>

                <a href="#about">
                <Button className="nav-link about">
                    <b>About</b>
                </Button>
                </a>

                <a href="#skills">
                <Button className="nav-link skills">
                    {" "}
                    <b>Skills</b>
                </Button>
                </a>

                <a href="#projects">
                <Button className="nav-link projects">
                    <b>Projects</b>
                </Button>
                </a>

                <a href="#contact">
                <Button className="nav-link contact">
                    <b>Contact</b>
                </Button>
                </a>
              </HStack>
            </HStack>
          </Flex>

          <Flex alignItems={"center"}>
            <Stack direction={"row"} spacing={7}>
              <Button onClick={toggleColorMode}>
                {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
              </Button>

              <Button
                backgroundColor="#a891b7"
                _hover={{ bg: "#a891b7", color: "black" }}
                color="white"
                variant="solid"
                onClick={onButtonClick}
                size={["sm", "md"]}
                id="resume-button-1"
                className="nav-link resume"
              >
                RESUME
              </Button>
            </Stack>
          </Flex>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          {isOpen ? (
            <Box pb={4} display={{ md: "none" }}>
              <Stack as={"nav"} spacing={4}>
                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Home">
                    {" "}
                    <b>Home</b>
                  </a>
                </Button>
                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Home">
                    {" "}
                    <b>Home</b>
                  </a>
                </Button>

                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Home">
                    {" "}
                    <b>Home</b>
                  </a>
                </Button>
                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Home">
                    {" "}
                    <b>Home</b>
                  </a>
                </Button>
                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Home">
                    {" "}
                    <b>Home</b>
                  </a>
                </Button>

                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#About">
                    <b>About</b>
                  </a>
                </Button>

                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Skills">
                    {" "}
                    <b>Skills</b>
                  </a>
                </Button>

                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Projects">
                    <b>Projects</b>
                  </a>
                </Button>

                <Button
                  onClick={isOpen ? onClose : onOpen}
                  _hover={{
                    textShadow: "#FC0 1px 0 10px",
                    transform: "scale(1.2)",
                  }}
                >
                  <a href="#Contact">
                    <b>Contact</b>
                  </a>
                </Button>
              </Stack>
            </Box>
          ) : null}
        </Flex>
      </Box>
    </div>
  );
}
